<template>
  <div class="container-fluid py-4 px-4 " style="min-height: 100vh;">
   
    <!-- PERFIL ENCABEZADO -->
   <div class="border rounded-3 px-4 py-3 bg-white shadow-sm mb-4
            d-flex flex-column flex-md-row align-items-center gap-3">

  <!-- CÍRCULO -->
  <div class="me-md-4">
    <label for="imageUpload" 
           class="image-upload-circle large d-flex justify-content-center align-items-center mx-auto">
      <span class="upload-text">Subir foto</span>
      <img id="previewImage" src="" alt="" style="display: none;" />
    </label>

    <input type="file" id="imageUpload" accept="image/*" style="display: none;" />
  </div>

  <!-- TEXTO -->
  <div class="text-center text-md-start">
    <h1 class="fw-bold mb-1">{{ nombreUsuario }}</h1>
    <span class="text-secondary fs-6">{{ glosa }}</span>
  </div>

</div>



    <!-- INFORMACIÓN PERSONAL -->
    <div class="card shadow rounded-3 mb-4">
      <div class="card-header bg-white border-0 d-flex align-items-center">
        <i class="bi bi-info-circle text-primary fs-5 me-2"></i>
        <h6 class="fw-bold text-primary m-0">INFORMACION PERSONAL</h6>
      </div>

      <div class="card-body rounded-3">
        <div class="row g-2">

          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-person fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">NOMBRE COMPLETO</p>
                <span class="fw-semibold tamaño ">{{ nombreUsuario }}</span>
              </div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-calendar fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">
                  FECHA DE NACIMIENTO
                </p>
                <span class="fw-semibold tamaño ">{{ formatearFecha(fechaNacimiento) }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-card-checklist  fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">
                  DNI / CE
                </p>
                <span class="fw-semibold tamaño ">{{ nroDni }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DATOS DE CONTACTO -->
    <div class="card shadow rounded-3 mb-4">
      <div class="card-header bg-white border-0 d-flex align-items-center">
        <i class="bi bi-info-circle text-primary fs-5 me-2"></i>
        <h6 class="fw-bold text-primary m-0">DATOS DE CONTACTO</h6>
      </div>

      <div class="card-body rounded-3">
        <div class="row g-2">
          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-envelope-at-fill fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">CORREO PERSONAL
                </p>

                <span class="fw-semibold tamaño ">{{ correoPersonal }}</span>
              </div>
            </div>

          </div>


          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-phone fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">TELEFONO CELULAR</p>
                <span class="fw-semibold tamaño ">{{ celular }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-telephone fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">TELEFONO FIJO</p>
                <span class="fw-semibold tamaño ">{{ telefonoAdicional }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-geo-alt fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">DEPARTAMENTO</p>
                <span class="fw-semibold tamaño ">{{ departamento }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-building fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold"> PROVINCIA</p>
                <span class="fw-semibold tamaño ">{{ provincia }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-map fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">DISTRITO</p>
                <span class="fw-semibold tamaño ">{{ distrito }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-signpost fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold">DIRECCION</p>
                <span class="fw-semibold tamaño">{{ direccion }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-houses fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold"> URBANIZACION</p>
                <span class="fw-semibold tamaño">—</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- CONTACTO DE EMERGENCIA -->
    <div class="card shadow rounded-3 mb-4">
      <div class="card-header bg-white border-0 d-flex align-items-center">
        <i class="bi bi-info-circle text-primary fs-5 me-2"></i>
        <h6 class="fw-bold text-primary m-0"> CONTACTO DE EMERGENCIA</h6>
      </div>
      <div class="card-body">
        <div class="row g-2">
          <div class="col-md-6">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-person-fill fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold"> NOMBRES</p>
                <span class="fw-semibold tamaño">{{ nombreContactEmergencia }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="border rounded-3 p-3 bg-white shadow-sm h-100 d-flex align-items-start">
              <i class="bi bi-phone-vibrate fs-3 text-primary me-3"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 color fw-bold"> TELEFONO</p>
                <span class="fw-semibold tamaño">{{ nroCelEmergencia }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA CONTACTOS REGISTRADOS -->
    <div class="card shadow rounded-3 mb-4">
      <div class="card-header bg-white border-0 d-flex align-items-center">
        <i class="bi bi-info-circle text-primary fs-5 me-2"></i>
        <h6 class="fw-bold text-primary m-0"> CONTACTOS REGISTRADOS</h6>
      </div>
      <div class="card-body">
        <div class="table-responsive mx-2 mt-2">
          <table class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th>ID</th>
                <th>NUMERO</th>
                <th>NOMBRE DEL CONTACTO </th>
              </tr>
            </thead>
            <tbody v-for="nombres in respuesta" :key="nombres.id">
              <tr v-if="nombres.idContacto != 0" class="text-center align-middle reducirTamaño">
                <td class="text-center">
                  {{ nombres.idContacto }}</td>
                <td class="text-center text-dark">
                  <i class="bi bi-person-fill me-1 text-info"></i>
                  {{ nombres.nroCelEmergencia }}
                </td>
                <td class="text-center">
                  <i class="bi bi-phone me-1 text-info"></i>
                  {{ nombres.nomConEmergencia }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CopiasDatosUser",

  data() {
    return {
      usuarios: "",
      respuesta: [],
      nombreUsuario: "",
      glosa: "",
      fechaNacimiento: "",
      nroDni: "",
      correoPersonal: "",
      celular: "",
      telefonoAdicional: "",
      departamento: "",
      provincia: "",
      distrito: "",
      direccion: "",
      nombreContactEmergencia: "",
      nroCelEmergencia: "",
    };
  },

  mounted() {
    this.usuarios = localStorage.getItem("userId");
    this.axios.get(`Contrato/ObtenerDatosTrabajador/${this.usuarios}`).then((r) => {
      this.respuesta = r.data;
      this.nombreUsuario = r.data[0].nombreDocumento;
      this.glosa = r.data[0].glosa;
      this.fechaNacimiento = r.data[0].posFechaNacimiento;
      this.nroDni = r.data[0].posTipDocumento;
      this.correoPersonal = r.data[0].posCorreo;
      this.celular = r.data[0].posTelefono;
      this.telefonoAdicional = r.data[0].posTelAdicional;
      this.departamento = r.data[0].ubiDepartamento;
      this.provincia = r.data[0].ubiProvincia;
      this.distrito = r.data[0].ubiDistrito;
      this.direccion = r.data[0].posDireccion;
      this.nombreContactEmergencia = r.data[0].nomConEmergencia;
      this.nroCelEmergencia = r.data[0].nroCelEmergencia;

      console.log("servicios", r.data);
    });
     const imageInput = document.getElementById('imageUpload');
    const preview = document.getElementById('previewImage');
    const text = document.querySelector('.upload-text');

    imageInput.addEventListener('change', function () {
      const file = this.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function (e) {
          preview.src = e.target.result;
          preview.style.display = "block";
          text.style.display = "none";
        };
        reader.readAsDataURL(file);
      }
    });
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return "";
      const date = new Date(fecha);
      const dia = String(date.getDate()).padStart(2, "0");
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      const año = date.getFullYear();
      return `${dia}/${mes}/${año}`;
    },
  },
};
</script>

<style scoped>
.color {
  font-size: 0.75rem;
  font-weight: 700;
  color: #002c5d;
}

.tamaño {
  font-size: 0.65rem;
}

span {
  font-size: 0.75rem;
}

.bg-solimano {
  background: #0080c8;
}

.reducirTamaño {
  font-size: 0.65rem;
}
.image-upload-circle {
  border-radius: 50%;
  background-color: #f0f0f0;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  border: 3px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-upload-circle.large {
  width: 150px;
  height: 150px;
}

.image-upload-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-upload-circle:hover {
  border-color: #999;
}

.upload-text {
  position: absolute;
  color: #666;
  font-size: 18px;
  text-align: center;
  pointer-events: none;
}
</style>
